import type { JSX } from 'react';
import { DateTime } from '@ksyos/date-time';
import { Badge, Col, FormGroup, FormParagraph, Row } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { getBadge } from '@common/utils/caroInactivityUtil';
import { getBariPostCountsOfCaroInactivityReportsAndNotifications } from '@common/utils/getBariPostCountsOfCaroInactivityReportsAndNotifications';
import { ProcessContext } from '@frontend/components/pages/episodeCategory/carePath/process/processContext';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';

type BariPostCaroInactivityProps = Readonly<{
    showReportCounts?: boolean;
    untilProcessActivityId?: string;
}>;

export function BariPostCaroInactivity(props: BariPostCaroInactivityProps): JSX.Element {
    const { showReportCounts, untilProcessActivityId } = props;
    const { process } = useDefinedContext(ProcessContext);
    const [countOfInactivityReportsForBodyWeight, setCountOfInactivityReportsForBodyWeight] = useState(0);
    const [countOfInactivityReportsForQuestionnaires, setCountOfInactivityReportsForQuestionnaires] = useState(0);
    const [countOfNotificationsForBodyWeight, setCountOfNotificationsForBodyWeight] = useState(0);
    const [countOfNotificationsForQuestionnaires, setCountOfNotificationsForQuestionnaires] = useState(0);

    useEffect(() => {
        loadCountsOfInactivityReportsAndNotifications();
    }, [untilProcessActivityId, process]);

    return (
        <FormGroup label="Inactiviteit">
            {countOfNotificationsForBodyWeight > 0 && (
                <Row columnGap={2}>
                    <Col>
                        <FormParagraph>Gewicht niet ingevuld</FormParagraph>
                    </Col>
                    <Col>{showReportCounts && <Badge {...getBadge(countOfInactivityReportsForBodyWeight + 1)} />}</Col>
                </Row>
            )}
            {countOfNotificationsForQuestionnaires > 0 && (
                <Row columnGap={2}>
                    <Col>
                        <FormParagraph>OBESI-Q niet ingevuld</FormParagraph>
                    </Col>
                    <Col>
                        {showReportCounts && <Badge {...getBadge(countOfInactivityReportsForQuestionnaires + 1)} />}
                    </Col>
                </Row>
            )}
        </FormGroup>
    );

    function loadCountsOfInactivityReportsAndNotifications() {
        const untilProcessActivity = process.activities.find((activity) => activity.id === untilProcessActivityId);
        const untilDateTime = untilProcessActivity?.performedDatetime
            ? DateTime.from(untilProcessActivity.performedDatetime)
            : undefined;
        const counts = getBariPostCountsOfCaroInactivityReportsAndNotifications(process.activities, untilDateTime);
        setCountOfInactivityReportsForBodyWeight(counts.countOfInactivityReportsForBodyWeight);
        setCountOfInactivityReportsForQuestionnaires(counts.countOfInactivityReportsForQuestionnaires);
        setCountOfNotificationsForBodyWeight(counts.countOfNotificationsForBodyWeight);
        setCountOfNotificationsForQuestionnaires(counts.countOfNotificationsForQuestionnaires);
    }
}
